/* @flow */
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import Input from 'components/Input.jsx';
import focusNode from 'utils/focusNode';

import './styles/PrependedTextInput.scss';

class PrependedTextInput extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    prepend: PropTypes.string,
  };

  _inputEl: ?window.HTMLElement;

  getInputNode = () => {
    return this._inputEl;
  };

  getValue = () => {
    if (this._inputEl) {
      return this._inputEl.value;
    }

    return 'error';
  };

  handleFocus = () => {
    focusNode(this.getInputNode());
  };

  render() {
    return (
      <div className="PrependedTextInput" onFocus={this.handleFocus}>
        <span className="PrependedTextInput-prepend">{this.props.prepend}</span>
        <Input
          {...this.props}
          ref={el => {
            this._inputEl = el;
          }}
          className={cx('PrependedTextInput-input', this.props.className)}
          type="text"
        />
      </div>
    );
  }
}

export default PrependedTextInput;
